document.addEventListener('alpine:init', () => {
	window.Alpine.data('quantityInput', () => ({
		init() {},

		selectOnChange(event) {
			event.preventDefault()

			if (Number.parseInt(event.target.value) === 11) {
				const input = event.target
					.closest("[x-data='quantityInput']")
					.querySelector("input[type='number']")

				input.value = '11'
				input.parentElement.classList.remove('hidden')
				input.parentElement.classList.add('flex')
				input.setAttribute('name', event.target.getAttribute('name'))

				event.target.remove()
			}
		},

		increment(event) {
			event.preventDefault()

			const input = event.target
				.closest("[x-data='quantityInput']")
				.querySelector("input[type='number']")
			const max = Number.parseInt(input.getAttribute('max'))
			const value = Number.parseInt(input.value)

			if (Number.isNaN(max) || value < max) {
				input.value = value + 1
				input.dispatchEvent(new Event('input', { bubbles: true }))
			}
		},

		decrement(event) {
			event.preventDefault()

			const input = event.target
				.closest("[x-data='quantityInput']")
				.querySelector("input[type='number']")
			const min = Number.parseInt(input.getAttribute('min'))
			const value = Number.parseInt(input.value)

			if (value > min) {
				input.value = value - 1
				input.dispatchEvent(new Event('input', { bubbles: true }))
			}
		},
	}))
})
